'use strict';

const DEFAULT_LOCALE = 'en';
const SUPPORTED_LOCALES = ['cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'it', 'ja', 'ko', 'nb', 'nl', 'pl', 'pt-BR', 'pt-PT', 'sv', 'th', 'tr', 'vi', 'zh-CN', 'zh-TW'];

exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.SUPPORTED_LOCALES = SUPPORTED_LOCALES;
